const homeworkStorage  = {
  state:{
    homework_subject_id:null
  },
  mutations:{
    SET_HOMEWORK_SUBJECT_ID_MUTATION:(state, payload) => {
      state.homework_subject_id = payload
    }

  },
  actions:{
    SET_HOMEWORK_SUBJECT_ID:({commit}, payload) => {
      commit('SET_HOMEWORK_SUBJECT_ID_MUTATION', payload)
    }
  },
  getters:{
    get_homework_subject_id (state) {
      return state.homework_subject_id
    }
  }
}

export default homeworkStorage